import { Router } from "@angular/router";
import { of } from "rxjs";
import { take, timeout } from "rxjs/operators";
import { ConstantService } from "../../shared/services/constant.service";

const ACCESS_TIMEOUT_MS = 15000;

// Sends a signed-in user to their first page once their user type is known:
// Customers if they may open the menu pages, otherwise the Support Landing page.
// Falls back to Issues if the user type takes too long or the navigation fails.
export function goToLandingPage(router: Router, constService: ConstantService): void {
  constService.accessResolved$
    .pipe(take(1), timeout({ first: ACCESS_TIMEOUT_MS, with: () => of(false) }))
    .subscribe((canOpenPages) => {
      const target = canOpenPages ? "/customers" : "/issues";
      router.navigateByUrl(target)
        .then((navigated) => {
          if (!navigated && target !== "/issues") {
            router.navigateByUrl("/issues");
          }
        })
        .catch(() => router.navigateByUrl("/issues"));
    });
}
